export default "__VITE_ASSET__BU7vj7lc__"